<script>
export default {
  name: 'TimelineEvent',
  props: {
    date: String,
    title: String
  }
};
</script>

<template>
  <li :data-date="date" class="timeline-event">
    <!-- Title -->
    <h3 class="timeline-title">
      <slot v-if="$slots.title" name="title" />
      <span v-else>{{ title }}</span>
    </h3>

    <!-- Content -->
    <div class="timeline-content">
      <slot />
    </div>
  </li>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.timeline-event {
  position: relative;
  border-bottom: 1px solid darken($--color-gray-10, 2.5%);
  padding: 1.5rem;
  margin: 0 1rem;

  @include breakpoint('md-and-down') {
    padding: 1.5rem;
  }

  .timeline-title {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;

    @include breakpoint('md-and-down') {
      font-size: 1.1rem;
    }

    h1,
    h2,
    h3 {
      font-size: inherit;
      margin-bottom: 0;
    }
  }

  .timeline-content {
    font-size: $--font-size-small;
  }

  &:last-child {
    border-bottom: none;
  }

  &:before,
  &:after {
    display: block;
    position: absolute;
    top: 0;
  }

  &:before {
    content: attr(data-date);
    position: absolute;
    width: 10rem;
    left: -13rem;
    top: 1.7rem;
    text-align: right;
    font-size: $--font-size-small;
    color: $--color-gray-40;

    @include breakpoint('md-and-down') {
      position: static;
      width: auto;
      text-align: left;
      margin-bottom: 0.5rem;
    }
  }

  &:after {
    content: '';
    top: 1.9rem;
    left: -1.45rem;
    height: 0.75rem;
    width: 0.75rem;
    box-shadow: 0 0 0 0.2rem $--color-primary;
    background-color: $--color-white;
    border-radius: 50%;

    @include breakpoint('md-and-down') {
      top: 1.7rem;
    }
  }
}
</style>
